import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { MapWellWaterSystemsMetricsInitialState } from '../mapWellWaterSystemMetrics.slice'
import { IMapWellWaterSystemsMetrics, RequestConfig } from '../../../../types';

export const fetchMapWellWaterSystemMetricsAsync = createAsyncThunk(
  'metrics/fetchWellMapMetrics',
  async ({ options }: { options?: RequestConfig },
    { rejectWithValue },) => {
    try {
      const response = await EpaApi.fetchMapWellWaterSystemsMetrics(options);
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchMapWellWaterSystemMetricsAsyncBuilder = (
  builder: ActionReducerMapBuilder<MapWellWaterSystemsMetricsInitialState>
) => {
  builder.addCase(fetchMapWellWaterSystemMetricsAsync.pending, (state) => {
    state.loading = true;
    state.success = false;
    state.error = '';
  });

  builder.addCase(
    fetchMapWellWaterSystemMetricsAsync.fulfilled,
    (state, action: PayloadAction<IMapWellWaterSystemsMetrics>) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    }
  );

  builder.addCase(
    fetchMapWellWaterSystemMetricsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  );
};